export default {"src":"/_next/static/media/na.5b8ea90c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};